// 数据统计文案
export default {
  共: ' ',
  个展览: 'All Exhibitions ',
  个云会议: 'All Conferences ',
  家云企业: 'Companies in Total',
  个云产品: 'Products in Total',
  个云直播: 'Live Streams in Total',
  个工程商: 'Contractors in Total',
  个设计师: 'Designers in Total',
  个云头条: 'Industry News in Total',
  个云会展: 'Virtual Exhibitions in Total',
  个全球展: 'Offline Exhibitions in Total',
  个云模型: 'Designs in Total',
  个云海报: 'Poster Templates in Total',
  个云招标: 'Tenders in Total',
  近期开幕有: '近期开幕有',
  近期开幕展览: 'Upcoming Exhibitions',
  近期开幕会议: 'Upcoming Conferences',
}
